import React, { useMemo } from 'react'
import styles from 'modules/Services/Network/network.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import SliderBanner from 'components/Banners/SliderBanner'
import { Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import Breadcrumbs from 'components/Breadcrumbs'
import HighRiskLabel from 'modules/Services/Network/subcomponents/HighRiskLabel'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import ROUTES from 'constants/router'
import clsx from 'clsx'
import NetworkBalanceColumn from 'modules/Services/Network/subcomponents/NetworkBalanceColumn'
import PageHeader from 'components/PageHeader'

const NetworkItemHeader = ({ title, totallyEmptyList, networkId, networkType }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  const breadcrumbsConfig = useMemo(
    () => [
      {
        title: t('services::heading'),
        to: pathGen(ROUTES.SERVICES),
      },
      {
        title: `${t(`services::networks.${networkType}`)}${
          networkType.match(/high-risk$/) ? ' (High Risk)' : ''
        }`,
        to: pathGen(ROUTES.SERVICES_NETWORK, {
          networkType,
        }),
      },
    ],
    [networkType, t],
  )

  return (
    <div className={styles['network-item']}>
      <Grid
        justifyContent={'between'}
        className={clsx('', {
          ['margin-bottom-40']: !totallyEmptyList,
        })}
        direction={'column'}
      >
        <Breadcrumbs
          links={breadcrumbsConfig}
          title={title}
          className={styles['network-item__breadcrumbs']}
        />

        {!totallyEmptyList && (
          <Grid
            alignItems={'start'}
            direction={'column'}
            centered={breakpoints.sm}
            gap={breakpoints.fbs ? 16 : breakpoints.lg ? 32 : 40}
          >
            {networkType && (
              <>
                <Grid direction={'row'} fluid={false} alignItems={'center'} vAlign={'top'} gap={16}>
                  <Grid gap={8} fluid={false} justifyContent={'center'}>
                    <PageHeader>{t(`services::networks.${networkType}`)}</PageHeader>
                    {networkType.match(/high-risk$/) && <HighRiskLabel size={'s'} />}
                  </Grid>
                </Grid>
              </>
            )}

            <SliderBanner
              placement="network_page"
              network={networkId}
              className={styles['banner-container']}
            />

            {breakpoints.md && <NetworkBalanceColumn networkType={networkType} />}
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default NetworkItemHeader

NetworkItemHeader.propTypes = {
  title: PropTypes.string,
  totallyEmptyList: PropTypes.bool,
  networkId: PropTypes.string,
  networkType: PropTypes.string,
}
